import PropTypes from 'prop-types'
import React from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

import DynamicImage from 'components/DynamicImage'

import laptop from './assets/straight-macbook-bg.png'
import { Frame, FrameMacStraightDynamic, LaptopImg, ImageBox } from './styles'

/**
 * Component to print some images on the screen on the macbook's image
 *
 * @param {object} props - Properties of the component
 * @returns {function} function - FrameMacStraight
 */
const FrameMacStraight = React.forwardRef((props, ref) => {
  const { src, node, className, children, alt } = props
  let content = null

  if (src && !node) {
    content = (
      <TransitionGroup component={null}>
        <CSSTransition timeout={{ enter: 400, exit: 700 }} key={src}>
          {state => (
            <ImageBox transitionState={state}>
              <DynamicImage
                image={src}
                alt={alt}
                imageSizes={{
                  xs: 400,
                  md: 500,
                }}
              />
            </ImageBox>
          )}
        </CSSTransition>
      </TransitionGroup>
    )
  }

  if (node && !src) {
    content = node
  }

  return (
    <FrameMacStraightDynamic ref={ref} className={className}>
      <LaptopImg alt="laptop" src={laptop} />
      <Frame>{content}</Frame>
      {children}
    </FrameMacStraightDynamic>
  )
})

FrameMacStraight.propTypes = {
  /** Alternate text for image */
  alt: PropTypes.string.isRequired,

  /** You can pass here some node to render it after frame */
  children: PropTypes.node,

  /** Class names for wrapper */
  className: PropTypes.string,

  /** You can pass here some custom node to render it instead of transition image */
  node: PropTypes.node,

  /** Path to image to show it inside frame */
  src: PropTypes.string,
}

FrameMacStraight.defaultProps = {
  className: '',
  children: null,
}

export default FrameMacStraight
